import React from 'react';
import {can} from '../../../../_common/components/Permissions';
import {toAbsoluteUrl} from '../../../../../../_metronic/_helpers';
import config from '../../../../../../config/common.json';

export function ActionsColumnFormatter(
  cellContent,
  row,
  rowIndex,
  {history}
) {
  const handleClick = () => history.push(`/user/${row._id}`);
  const goToAdminLogin = () => {
    const params = new URLSearchParams({username: row.username});
    const url = process.env.NODE_ENV === 'production' ? config.client_URL : config.dev_client_URL;
    const link = `${url}/adminLogin?${params.toString()}`;
    window.open(link, '_blank').focus();
  };
  const goToTransfersByAgent = () => {
    if (row.agentId) {
      history.push(`/transfersByAgent/${row.agentId}`);
    }
  };

  return can('view', 'userPage') && (
    <div className={'d-flex justify-content-center'}>
      {can('view', 'userPage') && (
        <a
          title="לערוך"
          className="btn btn-icon btn-light btn-sm mx-2 custom-action-button"
          onClick={handleClick}
        >
          <img
            src={toAbsoluteUrl('/media/svg/WriteBrandColor.svg')}
            alt="edit"
          />
        </a>
      )}
      {can('full', 'userPage') && (
        <a
          title="התחבר כמשתמש"
          className="btn btn-icon btn-light btn-sm mx-2 custom-action-button"
          onClick={goToAdminLogin}
        >
          <img
            src={toAbsoluteUrl('/media/svg/User-brandColor.svg')}
            alt="loginAsUser"
          />
        </a>
      )}
      {can('full', 'userPage') && (
        <a
          title="העברות"
          className={`btn btn-icon btn-light btn-sm mx-2 custom-action-button 
          ${row.agentId ? '' : 'custom-disabled-button cursor-default opacity-60'}
          `}
          onClick={goToTransfersByAgent}
        >
          <img
            src={toAbsoluteUrl('/media/svg/Transfers_brandColor.svg')}
            alt="loginAsUser"
          />
        </a>
      )}
    </div>
  );
}
